// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonGhost_default__dIqcF","fullWidth":"ButtonGhost_fullWidth__a81cV"};